export default __webpack_public_path__ + "static/hero-bg2-tablet-7bfb6081e7ab59ed197c0eef22352670.jpg";